var _rect, _rect2, _rect3, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupLoginBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1169,
    height: 352,
    viewBox: "0 0 1169 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1064.81,
    y: -262,
    width: 206.085,
    height: 704.379,
    transform: "rotate(60 1064.81 -262)",
    fill: "url(#login_paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 206.085,
    height: 704.379,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 103.042 -262)",
    fill: "url(#login_paint1_linear)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1065.44,
    y: -178.664,
    width: 206.085,
    height: 704.379,
    transform: "rotate(60 1065.44 -178.664)",
    fill: "url(#login_paint2_linear)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 206.085,
    height: 704.379,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 103.673 -178.664)",
    fill: "url(#login_paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "login_paint0_linear",
    x1: 1167.85,
    y1: -262,
    x2: 1167.85,
    y2: 442.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF976",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login_paint1_linear",
    x1: 103.042,
    y1: 0,
    x2: 103.042,
    y2: 704.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF976",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login_paint2_linear",
    x1: 1168.48,
    y1: -178.664,
    x2: 1168.48,
    y2: 525.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF976",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login_paint3_linear",
    x1: 103.042,
    y1: 0,
    x2: 103.042,
    y2: 704.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF976",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupLoginBg);
export default __webpack_public_path__ + "static/media/signup_login_bg.42f76824.svg";
export { ForwardRef as ReactComponent };